export default __webpack_public_path__ + "d72291b14698c16da314cf9fa5dd1d9d.png";